<!-- AnnouncementEditor.vue -->
<template>
  <div class="announcement-editor">
    <el-card>
      <div slot="header" style="font-weight: 600; color: #1d2129; font-size: 15px;">发布新公告</div>
      <el-form :model="announcementForm" :rules="rules" ref="formRef" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="announcementForm.title" placeholder="请输入公告标题" size="small" />
        </el-form-item>
        
        <el-form-item label="内容" prop="content">
          <el-upload
            class="upload-btn"
            action=""
            :http-request="uploadImage"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            accept="image/jpeg,image/jpg,image/png,image/gif"
            :limit="10"
            :file-list="imageFileList"
          >
            <el-button size="mini" type="primary" icon="el-icon-upload">上传图片</el-button>
          </el-upload>
          
          <el-input
            v-model="announcementForm.content"
            type="textarea"
            :rows="12"
            placeholder="请输入公告内容（支持HTML格式，上传图片后会自动插入图片标签）"
            size="small"
          />
          
          <div class="image-preview" v-if="previewImages.length > 0">
            <h4 style="margin: 8px 0; font-size: 14px; color: #4e5969;">图片预览：</h4>
            <div class="preview-list">
              <div class="preview-item" v-for="(img, index) in previewImages" :key="index">
                <img :src="img" alt="预览图片" class="preview-img">
                <el-button size="mini" type="text" @click="removeImage(index)" style="color: #f53f3f;">删除</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-switch
            v-model="announcementForm.is_active"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm" size="small">发布公告</el-button>
          <el-button @click="resetForm" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    baseurl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      announcementForm: {
        title: '',
        content: '',
        is_active: true
      },
      rules: {
        title: [
          { required: true, message: '请输入公告标题', trigger: 'blur' },
          { min: 2, max: 100, message: '标题长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' },
          { min: 5, message: '内容长度不能少于 5 个字符', trigger: 'blur' }
        ]
      },
      imageFileList: [],
      previewImages: [],
      uploadLoading: false
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB！');
        return false;
      }
      const isImage = /\.(jpeg|jpg|png|gif)$/i.test(file.name);
      if (!isImage) {
        this.$message.error('仅支持上传JPG、PNG、GIF格式的图片！');
        return false;
      }
      this.uploadLoading = true;
      return true;
    },
    
    async uploadImage(options) {
      try {
        const formData = new FormData();
        formData.append('file', options.file);
        
        const response = await fetch(`${this.baseurl}/upload/announcement`, {
          method: 'POST',
          credentials: 'include',
          body: formData
        });
        
        const data = await response.json();
        if (data.success) {
          options.onSuccess(data);
        } else {
          options.onError(new Error(data.message));
        }
      } catch (error) {
        options.onError(error);
      }
    },
    
    uploadSuccess(res) {
      this.uploadLoading = false;
      if (res.success) {
        this.previewImages.push(res.data.url);
        this.announcementForm.content += `<br><img src="${res.data.url}" style="max-width: 100%; height: auto;" alt="公告图片"><br>`;
        this.$message.success('图片上传成功！');
      }
    },
    
    uploadError(error) {
      this.uploadLoading = false;
      this.$message.error('图片上传失败：' + (error.message || '网络错误'));
    },
    
    removeImage(index) {
      const imgUrl = this.previewImages[index] || '';
      this.previewImages.splice(index, 1);
      this.announcementForm.content = this.announcementForm.content.replace(
        new RegExp(`<br><img src="${imgUrl}"[^>]+><br>`, 'g'),
        ''
      );
      this.$message.info('图片已移除');
    },
    
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            const response = await fetch(`${this.baseurl}/announcements`, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(this.announcementForm)
            });
            
            const data = await response.json();
            
            if (data.success) {
              this.$message.success('公告发布成功！');
              this.resetForm();
              this.$emit('announcement-created');
            } else {
              this.$message.error(data.message || '发布失败');
            }
          } catch (error) {
            console.error('发布公告错误:', error);
            this.$message.error('网络错误，发布失败');
          }
        } else {
          this.$message.warning('请完善表单信息');
        }
      });
    },
    
    resetForm() {
      this.$refs.formRef.resetFields();
      this.announcementForm = {
        title: '',
        content: '',
        is_active: true
      };
      this.previewImages = [];
      this.imageFileList = [];
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.announcement-editor {
  padding: 0;
}

:deep(.el-card) {
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  box-shadow: none;
}

:deep(.el-card__header) {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f3f5;
  background: #fafafa;
}

:deep(.el-card__body) {
  padding: 16px 20px;
}

:deep(.el-form-item) {
  margin-bottom: 16px;
}

:deep(.el-form-item__label) {
  font-size: 14px;
  color: #4e5969;
}

:deep(.el-input__inner) {
  height: 32px;
  border-radius: 4px;
  border: 1px solid #d0d3d9;
  font-size: 14px;
  color: #1d2129;
}

:deep(.el-input__inner:hover) {
  border-color: #c0c4cc;
}

:deep(.el-input__inner:focus) {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

:deep(.el-textarea__inner) {
  border-radius: 4px;
  border: 1px solid #d0d3d9;
  font-size: 14px;
  color: #1d2129;
  font-family: inherit;
}

:deep(.el-textarea__inner:hover) {
  border-color: #c0c4cc;
}

:deep(.el-textarea__inner:focus) {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

:deep(.el-button) {
  border-radius: 4px;
  font-size: 13px;
  padding: 6px 14px;
}

:deep(.el-button--primary) {
  background: #1677ff;
  border: none;
}

:deep(.el-button--primary:hover) {
  background: #4096ff;
}

:deep(.el-button--primary:active) {
  background: #0958d9;
}

:deep(.el-button--mini) {
  padding: 4px 10px;
  font-size: 13px;
}

.upload-btn {
  margin-bottom: 8px;
}

.image-preview {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #f2f3f5;
}

.preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
}

.preview-item {
  position: relative;
  border: 1px solid #e5e6eb;
  padding: 4px;
  border-radius: 4px;
  background: #fff;
}

.preview-img {
  width: 120px;
  height: auto;
  border-radius: 4px;
  display: block;
}

.preview-item .el-button {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #fff;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
}

:deep(.el-switch) {
  height: 24px;
}

:deep(.el-switch .el-switch__core) {
  width: 40px;
  height: 20px;
  border-radius: 10px;
}

:deep(.el-switch .el-switch__core .el-switch__button) {
  width: 16px;
  height: 16px;
}

:deep(.el-switch.is-checked .el-switch__core) {
  border-color: #1677ff;
  background-color: #1677ff;
}

@media (max-width: 768px) {
  :deep(.el-card__body) {
    padding: 12px 14px;
  }
  
  .preview-img {
    width: 80px;
  }
}
</style>